import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import routes from "./routes/route";
import UserActivityProvider from "./userActivityProvider";
import { AuthProvider } from "./components/contexts/AuthContext"; // ✅ import AuthProvider
import { GuestProvider } from "./components/contexts/GuestContext"; // ✅ import GuestProvider
import { Toaster } from "sonner";
import TypingLoader from "./components/helpers/TypingLoader";
import BubbleNetwork from "./components/logo/BubbleNetwork";

function App() {
  return (
    <AuthProvider> {/* ✅ Wrap your entire app in AuthProvider */}
      <GuestProvider> {/* ✅ Guest session context */}
        <UserActivityProvider> {/* 🟢 Wrap your whole app here */}
          <Toaster position="top-center" richColors />
          <Suspense fallback={<TypingLoader text={'Medhas AI'}/>}>
            <RouterProvider router={routes} />
          </Suspense>
        </UserActivityProvider>
      </GuestProvider>
    </AuthProvider>
  );
}

export default App;
